<template>
  <div id="goodsedit">
    <div class="goodsAddBlock">
      <el-form
        id="gForm"
        ref="gForm"
        size="small"
        :model="gForm"
        :rules="formRule"
        label-position="top"
      >
        <el-form-item class="input" prop="title">
          <label class="lb">
            <span>*</span>标题
          </label>
          <el-input class="input_normal" size="small" v-model="gForm.title"></el-input>
        </el-form-item>
		
		<el-form-item class="input" prop="title">
		  <label class="lb">
		    <span>*</span>类型
		  </label>
		  <el-input class="input_normal" size="small" v-model="gForm.type"></el-input>
		</el-form-item>
		<el-form-item class="input" prop="title">
		  <label class="lb">
		    <span>*</span>语言
		  </label>
		  <el-input class="input_normal" size="small" v-model="gForm.lang"></el-input>
		</el-form-item>
        <el-form-item class="input" prop="content">
          <label class="lb">
            <span>*</span>内容
          </label>
          <quilleditor
            class="editerBox"
            v-model="gForm.content"
            ref="myTextEditor"
            :options="editorOption"
            @change="onChange"
          >
            <div id="toolbar" slot="toolbar">
              <select class="ql-size">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
              <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
              <span class="ql-formats">
                <button type="button" @click="imgClick" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
                      class="ql-even ql-fill"
                      points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
                    />
                  </svg>
                </button>
              </span>
            </div>
          </quilleditor>
        </el-form-item>
        <el-form-item class="input" prop="submit">
          <el-button
            class="btn1 submitbtn"
            type="primary"
            @click="preSubmit()"
          >{{$t("normal_sure")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "goodsedit",
  props: {
    value: {
      type: String
    },
    uploadUrl: {
      type: String,
      default: "/skinMgrSrv/goods/upload"
    },
    fileName: {
      type: String,
      default: "file"
    },
    maxUploadSize: {
      type: Number,
      default: 1024 * 1024 * 2048
    }
  },
  data() {
    return {
      title: "",
      doing: false,
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: "#toolbar"
        }
      },
      gForm: {
        id: "",
        title: "",
        content: "",
        type: "",
		lang: ''
      },
      formRule: {
        title: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        type: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        content: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ]
      }
    };
  },
  components: {
    quilleditor: quillEditor
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },
  mounted() {
	if(this.value){
		this.gForm.content = this.value
	}
    this.title = '操作文案管理';
  },
  watch: {
    value(newVal, oldVal) {
      if (this.editor) {
        if (newVal !== this.gForm.content) {
          this.gForm.content = newVal
        }
      }
    }
  },
  created() {
    if (localStorage.edit_tips_id && localStorage.edit_tips_id > 0) {
      this.gForm.id = localStorage.edit_tips_id;
      this.title = '操作文案管理';
    }
    this.getGoods()
  },
  methods: {
    handleCheckedTypesChange(value){
      if(value.length > 3){
        this.$message('最多选择3个')
		var arr = new Array()
		for(var i=0; i < 3; i++){
			arr.push(this.type_id_arr[i])
		}
        this.type_id_arr = arr
      }
	  this.gForm.type_ids = this.type_id_arr.join(',')
	  console.log(this.gForm.type_ids)
    },
    cnumber(i){
      if(i<10){
        return '0'+i;
      }
      return ''+i;
    },
    onChange() {
      this.$emit("input", this.gForm.content);
    },
    onFileChange(e) {
      let fileInput = e.target;
      if (fileInput.files.length === 0) {
        return;
      }
      if (fileInput.files[0].size > this.maxUploadSize) {
        this.$alert(
          this.$i18n.t("imagelimit2m"),
          this.$i18n.t("imagelimit2big"),
          {
            confirmButtonText: this.$i18n.t("normal_sure"),
            type: "warning"
          }
        );
      }
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let data = new FormData();
      data.append(this.fileName, fileInput.files[0]);
      let _this = this;
      this.axios.post(this.uploadUrl, data, config).then(function(response) {
        if (response.data) {
          let ii = _this.editor.getSelection()
            ? _this.editor.getSelection().index
            : 0;
		  let allurl = response.data.imgUrl
		  if(allurl.indexOf('http') == -1){
			  allurl = 'https://zm.yimei.ai/fileSvr/get/' + allurl
		  }
          _this.editor.insertEmbed(ii, "image", allurl);
        }
      });
    },
    imgClick() {
      if (!this.uploadUrl) {
        console.log("no editor uploadUrl")
        return
      }
      let input = document.createElement("input")
      input.type = "file"
      input.name = this.fileName
      input.accept = "image/jpeg,image/png,image/jpg,image/gif"
      input.onchange = this.onFileChange
      input.click()
    },
    preSubmit() {
      let _this = this
      this.$refs["gForm"].validate(valid => {
        if (valid) {
          _this.submit()
        } else {
          console.log("error!")
          return false
        }
      })
    },
    submit() {
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {}
      Object.assign(data,this.gForm)
      if(data.ext_rules){
          data.ext_rules = JSON.stringify(data.ext_rules)
      }

      this.axios
        .post("/skinMgrSrv/tips/edit", this.formData(data))
        .then(function(response) {
          _this.doing = false
          if (response.data.msg) {
            _this.$message(response.data.msg)
          }
          if (response.data.code === 0) {
            localStorage.edit_tips_id = 0;
            _this.$router.push({ path: "/skinmgr/tipsList" })
          }
          console.log(response.data)
        })
    },
    cansal() {
      localStorage.activeMenu = this.$i18n.t("goods_manager")
      this.$router.push({ path: "/skinmgr/tipsList" })
    },
    onEditorReady(editor) {
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    saveHtml: function(event) {
      alert(this.content);
    },
    getGoods() {
      if (
        !localStorage.edit_goods ||
        localStorage.edit_goods === -1 ||
        localStorage.edit_goods === "-1"
      ) {
        localStorage.edit_goods = ""
        this.gForm.id = ""
        return false
      }
      var goodsInfo = JSON.parse(localStorage.edit_goods)

      if(goodsInfo.type_ids){
         this.type_id_arr = goodsInfo.type_ids.split(',')
      }
      if(!goodsInfo.ext_rules){
          goodsInfo.ext_rules = {}
      }
      this.gForm=goodsInfo
    },
    handleAvatarSuccess(res, file) {
      this.gForm.goods_pic = URL.createObjectURL(file.raw)
      if (res.code === 0) {

        this.gForm.goods_pic = res.imgUrl
      }
      console.log(this.gForm.goods_pic )
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error(this.$i18n.t("image_fix_tips"))
      // }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t("image_big_tips_2"))
      }
      return isLt2M
    },
    getGoodsTypes(){
      if(sessionStorage.goodsTypeList){
        this.typeList = JSON.parse(sessionStorage.goodsTypeList)
        return true
      }
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/goods/typeList', {}).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.typeList = response.data.list
          sessionStorage.goodsTypeList = JSON.stringify(_this.typeList)
        }
      }).catch(function (res) {
          _this.doing = false
      })
    }
  }
};
</script>
<style  lang="scss">
#goodsedit {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-dialog__header {
    border-bottom: #e9e9e9 1px solid !important;
  }
  .el-form-item__error {
    margin-left: 128px;
  }
  .el-button--primary {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
  }
  .is-checked {
    span{
      color: #fff;
    }
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
  .el-checkbox-group {
    display: inline-block;
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
  .el-checkbox__inner {
    display: none;
  }
  .el-checkbox__label {
    padding-left: 0px;
  }
  .ql-container.ql-snow {
    min-height: 250px;
  }
  .checkboxContent{
    width: 8rem;
    max-width: 8rem;
  }
  .el-checkbox {
    margin-right: 5px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 75px;
    text-align: center;
    font-size: 12px;
  }
  .el-radio-button__inner{
    border: 0px;
    width: 55px;
    background-color: #fff;
  }
  .el-radio-button{
    margin-right: 5px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 55px;
    text-align: center;
    font-size: 12px;
  }

  .is-active {
    span{
      color: #fff;
    }
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
}
</style>

<style scoped lang="scss">
#goodsedit {
  margin: 0.1667rem;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0.04166rem;
  padding: 0.166rem;
  .goodsAddBlock {
    width: calc(100% - 0.11rem);
    min-height: 3.6rem;
    height: auto;
    display: block;
    margin-top: 0.0833rem;
    #gForm {
      width: calc(100% - 0.11rem);
      .submitbtn {
        margin-left: 1.2rem;
        width: 0.7rem;
      }
    }
  }
  .el-input .workfor {
    width: 1.25rem;
  }
  .input_normal {
    width: 2.5rem;
  }
  label.lb {
    width: 1rem;
    text-align: right;
    display: inline-block;
    margin-right: 0.1667rem;
    vertical-align: top;
    span {
      color: red;
    }
  }
  .tarea {
    margin-left: 0rem;
    width: 10rem;
  }
  .quill-editor {
    margin-left: 0rem;
    width: 8rem;
    min-height: 300px;
    display: inline-block;
  }
  .avatar-uploader {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin-top: 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1rem;
    height: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
  }
  .avatar {
    width: 1rem;
    height: 1rem;
    display: block;
    border: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/tips/edit.vue